import { onFind, initInScope } from "@elements/init-modules-in-scope";
import { on, find, findIn, findAllIn } from '@elements/dom-utils';
import Modal from 'bootstrap/js/dist/modal';

const selectors = {
    base: '.js-offertool',
    btn: '.js-offertool__btn',
    fieldsOld: '.js-offertool__field',
    addProduct: '.js-offertool__add-product',
    addProductResult: '.js-offertool__add-product-result',
    modal: 'dynamicModal'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let fieldsOld = findAllIn(selectors.fieldsOld, baseElement);

        const showSubmitBtn = () => {
            fieldsOld.forEach((field) => {
                field.setAttribute("hidden", true);
                btn.removeAttribute("hidden");
            })
        }

        on("change", function () {
            showSubmitBtn();
        }, baseElement)

        let modalElement = document.getElementById(selectors.modal);
        if (modalElement) {
            on('click', function (event) {
                let target = event.target.closest(selectors.addProduct);

                if (!target) return;

                event.preventDefault();

                let url = target.getAttribute('href');
                let wrapper = findIn(selectors.addProductResult, baseElement);

                let pendingRequest = fetch(url, {
                    method: "GET",
                });

                pendingRequest.then((response) => {
                    return response.json()
                }).then((response) => {
                    if (response && response.success) {
                        if (wrapper && response.html) {
                            wrapper.innerHTML = response.html;
                            initInScope(wrapper);
                            showSubmitBtn();
                        }

                        if (modalElement) {
                            let modalInstance = Modal.getInstance(modalElement);
                            if (modalInstance) {
                                modalInstance.hide();
                            }
                        }
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
            }, modalElement);
        }
    });
}